module.exports = __webpack_public_path__ + "img/crewneck-front.f06c78fa.svg";